const SWHeaderPrefix = "x-sw-";

export const VersionHeader: "x-sw-version" = `${SWHeaderPrefix}version` as const;
export const CacheHeader: "x-sw-cache" = `${SWHeaderPrefix}cache` as const;
export const ActiveCacheHeader: "x-sw-active-cache" = `${SWHeaderPrefix}active-cache` as const;
export const CacheResultHeader: "x-sw-cache-result" = `${SWHeaderPrefix}cache-result` as const;
export const CacheVersionHeader: "x-sw-cache-version" = `${SWHeaderPrefix}cache-version` as const;
export const CacheAgeHeader: "x-sw-cache-age" = `${SWHeaderPrefix}cache-age` as const;
export const CacheHostHeader: "x-sw-cache-host" = `${SWHeaderPrefix}cache-host` as const;
export const ProxyTypeHeader: "x-sw-proxy-type" = `${SWHeaderPrefix}proxy-type` as const;
